import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c3d7e9a0")

_pushScopeId("data-v-c3d7e9a0")
const _hoisted_1 = { class: "site-editor-shell" }
const _hoisted_2 = { class: "site-editor-toolbar" }
const _hoisted_3 = { class: "d-flex align-items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_9 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_10 = {
  key: 2,
  class: "text-success small"
}
const _hoisted_11 = {
  key: 3,
  class: "text-danger small"
}
const _hoisted_12 = {
  key: 4,
  class: "text-warning small"
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger mx-3 mt-3 mb-0"
}
const _hoisted_14 = {
  key: 1,
  class: "alert alert-success mx-3 mt-3 mb-0"
}
const _hoisted_15 = {
  ref: "devicesPanel",
  class: "site-editor-devices"
}
const _hoisted_16 = { class: "site-editor-workspace" }
const _hoisted_17 = {
  ref: "blocksPanel",
  class: "site-editor-blocks"
}
const _hoisted_18 = {
  ref: "editorHost",
  class: "site-editor-canvas"
}
const _hoisted_19 = { class: "site-editor-right" }
const _hoisted_20 = {
  ref: "layersPanel",
  class: "site-editor-layers"
}
const _hoisted_21 = {
  ref: "stylesPanel",
  class: "site-editor-styles"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/sites",
          class: "btn btn-sm btn-light"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.site?.name || 'Site editor'), 1),
          (_ctx.homePage)
            ? (_openBlock(), _createBlock("div", _hoisted_6, "Editing: " + _toDisplayString(_ctx.homePage.title), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        (_ctx.loadingEditor)
          ? (_openBlock(), _createBlock("span", _hoisted_8, "Loading editor..."))
          : (_ctx.saveState === 'saving')
            ? (_openBlock(), _createBlock("span", _hoisted_9, "Saving..."))
            : (_ctx.saveState === 'saved')
              ? (_openBlock(), _createBlock("span", _hoisted_10, "Saved"))
              : (_ctx.saveState === 'error')
                ? (_openBlock(), _createBlock("span", _hoisted_11, "Save failed"))
                : (_ctx.dirty)
                  ? (_openBlock(), _createBlock("span", _hoisted_12, "Unsaved changes"))
                  : _createCommentVNode("", true),
        _createVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light-primary",
          disabled: !_ctx.editorReady || _ctx.saveState === 'saving',
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args)))
        }, _toDisplayString(_ctx.saveState === 'saving' ? 'Saving...' : 'Save'), 9, ["disabled"]),
        _createVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light",
          disabled: !_ctx.editorReady,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPreview && _ctx.openPreview(...args)))
        }, " Preview ", 8, ["disabled"]),
        _createVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          disabled: !_ctx.editorReady || _ctx.publishing,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.publish && _ctx.publish(...args)))
        }, _toDisplayString(_ctx.publishing ? 'Publishing...' : 'Publish'), 9, ["disabled"])
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.publishMessage)
      ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.publishMessage), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_15, null, 512),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, null, 512),
      _createVNode("div", _hoisted_18, null, 512),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, null, 512),
        _createVNode("div", _hoisted_21, null, 512)
      ])
    ])
  ]))
})